import React from 'react';
import { TableHeaderCell } from './styles';

interface ICardProductGroupTableHeaderProps {
}

const CardProductGroupTableHeader: React.FC<ICardProductGroupTableHeaderProps> = ({
}) => {

  return (
    <tr>
      <TableHeaderCell width='120px'>SKU</TableHeaderCell>
      <TableHeaderCell>Nome</TableHeaderCell>
      <TableHeaderCell width='60px'>Código</TableHeaderCell>
    </tr>
  );

}

export { CardProductGroupTableHeader };